<template>
    <div id="errorpage">
      <div id="content" class="site-content">
        <main class="container-fluid px-0 px-md-1 text-center">
          <section class="row mb-30px mx-0 mx-md-1">
            <div class="col-12 col-md-10 px-0 px-md-1">
              <img
              v-if="imgPc"
                class="mb-30px img-404-pc"
                :src="imgPc"
                alt=""
              />
              <img
              v-if="imgMb"
                class="mb-30px img-404-mb"
                :src="imgMb"
                alt=""
              />
              <Heading
              level="1"
              class="mb-25px agp-normal text-center">
              Oops! Nothing Sparkly In Here
              </Heading>
              <p class="agp-light text-center px-3 px-md-1">We could not find the page you are looking for.</p>
            </div>
          </section>

          <section class="row pb-120px mx-0 mx-md-1 text-center">
            <div class="col-12 col-md-10 px-0 px-md-1 button-box">
              <NuxtLink
              target="_blank"
              class="btn btn-outline-dark back-to-home btn-back mb-10px"
              :to="getLangUrl('/shop', baseUrl, locale)"
              >Continue Shopping
              <span class="css-arrow css-arrow-right" style="border-color: rgb(33, 37, 41);"></span>
            </NuxtLink>
            <NuxtLink
              target="_blank"
              class="btn btn-outline-dark mb-10px"
              :to="getLangUrl('/', baseUrl, locale)"
              >Back To Home
              <span class="css-arrow css-arrow-right" style="border-color: rgb(33, 37, 41);"></span>
            </NuxtLink>
            </div>
          </section>
        </main>
      </div>
    </div>
  </template>
<script lang="ts" setup>
import Heading from '~/components/Heading.vue';
import imgPc from '~/assets/images/ErrorPageBanner-scaled.webp'
import imgMb from '~/assets/images/ErrorPageBanner_Mobile.webp'
const route = useRoute();
const { pushToDataLayer, pushPageTypeToDataLayer } = useCustomGtm();

const runtimeConfig = useRuntimeConfig();
    const baseUrl = runtimeConfig.public.BASE_URL;
    import { useI18n } from 'vue-i18n';
    const { locale } = useI18n();
    import { convertUrlsToLocale, getLangUrl } from '~/utils/getLangUrl';
// Check if the route has query parameters and redirect if necessary
if (Object.keys(route.query).length > 0) {
  // Redirect to a clean /404 page without any query parameters
  navigateTo('/404/', { redirectCode: 301 });
}
onMounted(() => {
  pushPageTypeToDataLayer('error page', {
    hierachy1: 'n/a',
    hierachy2: 'n/a',
    hierachy3: 'n/a',
  });
})

useHead({
  title: '404 - Page not found | SK Jewellery'
});
    console.log('Test Deploy');
</script>
<style scoped>
/* Add custom styles here */
#errorpage{
  background-color: #F8F8F8;
}
.pt-md-40px {
  padding-top: 40px;
}
.mb-30px {
  margin-bottom: 30px;
}
.mb-25px {
  margin-bottom: 25px;
}
.pb-120px {
  padding-bottom: 120px;
}
.agp-normal {
  font-weight: normal;
}
.agp-light {
  font-weight: lighter;
}
.button-box{
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;
}
.btn-back {
  /* margin-right: 10px; */
}
.btn-outline-dark {
  border: 1px solid #000;
  color: #000;
  border-radius: 0;
  font-weight: 400;
  padding: 8px 26px 6px 26px;
  background-size: auto 12px;
  display: inline-block;
  text-decoration: none;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
}
span.css-arrow.css-arrow-right {
  border: solid black;
  border-width: 0 1px 1px 0;
  display: inline-block;
  padding: 4px;
  -webkit-transform: rotate(-45deg);
  margin-left: 8px;
}
.text-center{
  text-align: center;
}
img{
  max-width: 100%;
}
.img-404-pc{
  display: inline;
}
.img-404-mb{
  display: none;
}
@media screen and (max-width:767px){

  .img-404-pc{
    display: none;
  }
  .img-404-mb{
    display: block;
  }
  .button-box{
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
}
@media screen and (max-width:578px){
  .button-box{
    flex-direction: column;
  }
  .btn-outline-dark{
    width: 70%;
  }
}
@media screen and (max-width:456px){
  .col-md-10{
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  .btn-back{
    /* margin-bottom: 20px; */
  }
}
</style>
